import { AttendanceFilterOptionValue, FilterKey } from '@studyportals/search-filters';
import { FilterSelectionState } from '@/filters/selection/FilterSelectionState';
import { DeliveryMethodEnum } from '@studyportals/search-api-interface';
import { SeoHeadingHandlerDefaultSorting } from '../SeoHeadingHandlerDefaultSort';

export class Attendance extends SeoHeadingHandlerDefaultSorting {
	protected async canHandleWithDefaultSorting(filterSelectionState: FilterSelectionState): Promise<boolean> {
		return (
			(await this.singleSelectionFor(FilterKey.DELIVERY_METHOD, filterSelectionState)) &&
			this.selectionOnlyFor([FilterKey.DELIVERY_METHOD], filterSelectionState)
		);
	}

	protected async selfHandle(filterSelectionState: FilterSelectionState): Promise<string> {
		const attendanceValue = this.getFilterOptionValueBy(FilterKey.DELIVERY_METHOD, filterSelectionState);

		if (attendanceValue === DeliveryMethodEnum.ONLINE) {
			return Promise.resolve(this.constructSeoInfoForOnline());
		}

		return Promise.resolve(this.constructSeoInfoForOtherThanOnline(filterSelectionState));
	}

	private constructSeoInfoForOnline(): string {
		return 'Study online at these universities';
	}

	private constructSeoInfoForOtherThanOnline(filterSelectionState: FilterSelectionState): string {
		const attendance = this.constructAttendanceDisplayName(filterSelectionState);
		return `Browse through our ${attendance} universities`;
	}

	private constructAttendanceDisplayName(filterSelectionState: FilterSelectionState): string {
		const attendance = this.getFilterOptionValueBy(FilterKey.DELIVERY_METHOD, filterSelectionState) ?? '';
		return attendance === AttendanceFilterOptionValue.FACE_2_FACE ? 'on campus' : attendance;
	}
}
